import { Col, requestResourceByName, useActivity } from 'ia-react-core';
import { ResourcesLoader } from 'omni-package-react-core';
import React, { FC } from 'react';
import { useDispatch } from 'react-redux';
import AvailableDocumentsModal from '../../components/AvailableDocumentsModal';
import DocumentList from '../../components/DocumentListResource/DocumentList';
import DocumentListResource from '../../components/DocumentListResource';
import DocumentsHeader from '../../components/DocumentsHeader';
import DocumentsSummaryResource from '../../components/DocumentsSummaryResource';
import DocumentsTypesResource from '../../components/DocumentsTypesResource';
import { StyledRow } from './DocumentsPage.styles';
import { DocumentListResourceInfo } from '../../components/DocumentListResource/DocumentListResource';

export interface DocumentsPageProps { }

const twentyNineMinutes = 1740000;

const DocumentsPage: FC<DocumentsPageProps> = () => {
  const dispatch = useDispatch();
  useActivity(() => {
    dispatch(requestResourceByName(DocumentListResourceInfo.name));
  }, [], { frequency: twentyNineMinutes, strategy: 'trailing' });

  return (
    <ResourcesLoader
      failIfAnyEssentialInError
      reloadEveryTime
      validateAvailability
    >
      <ResourcesLoader.Resources>
        <DocumentsSummaryResource />
        <DocumentsTypesResource />
        <DocumentListResource essential />
      </ResourcesLoader.Resources>
      <ResourcesLoader.Content>
        <AvailableDocumentsModal />
        <StyledRow>
          <Col xs={12} lg={8}>
            <DocumentsHeader />
          </Col>
        </StyledRow>
        <DocumentList />
      </ResourcesLoader.Content>
    </ResourcesLoader>
  );
};

export default DocumentsPage;
